(ns teamoesterreich.user-mode.navigation.app-bar
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.menu :refer [menu]]
            [reagent.core :as r]
            [teamoesterreich.config :as config]
            [teamoesterreich.store :as store]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.user-mode.actions :as a]))

;; see https://material-ui.com/components/app-bar/

(defn bar-menu [{:keys [!anchor tom-id admin-role publisher publisher-mode open on-hide]}]
  [mui/menu {:id              "menu-appbar"
             :anchorEl        @!anchor
             :transformOrigin {:vertical "bottom" :horizontal "right"}
             :style           {:paddingLeft "6px"}
             :open            open
             :onClose         on-hide}
   [mui/menu-item {:onClick (fn []
                              (on-hide)
                              (a/set-no-back-page :landing))}
    "Home"]


   (when (and tom-id admin-role)
     [mui/menu-item {:component "a"
                     :href      (str config/ADMIN_SERVER_URL)
                     :target    "_blank"
                     :style     {:color "red"}}
      "Admin Mode"])

   (if tom-id
     [mui/menu-item {:onClick (fn []
                                (on-hide)
                                (a/set-no-back-page :landing)
                                (a/logout)
                                )}
      "Logout"]
     [mui/menu-item {:onClick (fn []
                                (on-hide)
                                (a/open-login))}
      "Login"])
   [mui/divider]
   (if publisher
     [mui/form-group
      [mui/form-control-label
       {:style   {:paddingLeft "16px"}
        :label   "Redaktion Modus"
        ;:labelPlacement "Start"
        :control (r/as-element
                   [mui/switch
                    {
                     :checked  (or publisher-mode false)
                     :onChange (fn [_ v] (a/set-user-details {:publisher-mode v}))
                     }])}
       ]]
     )
   ])


(defn bar [{:keys [classes] :as props}]
  (r/with-let [!open (r/atom false)
               !menu-anchor (r/atom nil)
               !actual-user (r/cursor store/app-state [:actual-user])]

    [mui/app-bar
     {:position "static"
      :style    {:backgroundColor "white" :width "100vw" :overflow "hidden" :borderLeft 0 :borderRight 0 :margin-right "0" :margin-left "0"}}
     [mui/toolbar
      {:style {:backgroundColor "white" :display "flex" :flexDirection "row" :paddingRight 0 :paddingLeft 0}}
      ;[:f> (js/console.log "use-media-query"  (mui/use-media-query "(min-width:600px)"))]
      [:div {:className "nav-left" :style {:textAlign "left"}}
       [:img {:className "logo"
              :src       "/custom/img/banner.png" :alt (txt/txt :core "Team")
              :onClick   #(a/set-no-back-page :landing)
              :title     "Home"}]
       ]


      [:div {:className "nav-center" :style {:flex "1"}}
       [mui/typography {:className "build-info" :style {:color "black" :textAlign "left" :margin "20px 0 0 20px"}}
        (when config/TEST_MACHINE (str "Test Server Build: " config/BUILD_DATE))]]

      [:div {:className "nav-right" :style {:paddingRight "30px"}}
       [:a {:className "sub-logo rk" :href (txt/txt :core :combo_rk_link) :target "_blank"}
        [:img {:src (txt/txt :core :combo_rk) :alt (txt/txt :core "RK") :style {:paddingRight "10px"}}]]

       [:a {:className "sub-logo radio" :href (txt/txt :core :combo_radio_link) :target "_blank"}
        [:img {:src (txt/txt :core :combo_radio) :alt (txt/txt :core "RADIO") :style {}}]]]

      [:div {:className "nav-right" :style {:paddingRight "30px"}}
       [mui/icon-button
        {:edge     "end" :class (:button classes) :aria-label "menu"
         :style    {:height "50px"}
         :ref      #(reset! !menu-anchor %)
         :on-click #(swap! !open not)}
        [menu]]

       [bar-menu {:!anchor        !menu-anchor
                  :open           @!open
                  :on-hide        #(reset! !open false)
                  :tom-id         (:tom-id @!actual-user)
                  :admin-role     (:admin-role @!actual-user)
                  :publisher      (:publisher @!actual-user)
                  :publisher-mode (:publisher-mode @!actual-user)}]]]
     ]))